import React, {useState} from "react";

import "./user.modules.css"
import UserForm from "./UserForm";

const CreateUser: React.FC = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Users", url: "/users"},
        {content: "Add User", url: "/users/create"},
    ]);

    return (
        <UserForm crumbs={crumbs} title={"Add User"} btnText="Add"/>
    );
};
export default CreateUser;
